// src/redux/stockGroups/stockGroupAPI.js
import apiClient from "../../authentication/utils/core/axios";

const StockGroupAPI = {
  getGroupsForStock: async (ticker) => {
    // No dedicated /stocks/{ticker}/groups route exists -- the real backend
    // endpoint is the query-param-based search-by-stock route.
    const response = await apiClient.get(`/groups/search-by-stock`, { params: { ticker } });
    if (response.status !== 200) throw new Error('Failed to fetch groups for stock');
    return response.data;
  },

  getRecommendedGroupsForStock: async (ticker) => {
    const response = await apiClient.get(`/groups/recommended-for-stock/${encodeURIComponent(ticker)}`);
    if (response.status !== 200) throw new Error('Failed to fetch recommended groups for stock');
    return response.data;
  },

  // NOTE: there is no dedicated "list a group's stocks" backend endpoint --
  // a group's stocks come back embedded (`stocks: [...]`) in GET /groups/{id}.
  // Left unimplemented rather than pointed at a URL that doesn't exist;
  // callers should read stocks off the already-fetched group object instead.
  getStocksForGroup: async () => {
    throw new Error('getStocksForGroup has no backend endpoint -- use the stocks[] field from GET /groups/{id} instead');
  },

  associateStocksWithGroup: async (groupId, stockIds) => {
    // normalize so backend always gets { stock_ids: int } or { stock_ids: [int, ...] }
    const payload = Array.isArray(stockIds) ? { stock_ids: stockIds } : { stock_ids: stockIds };
    const response = await apiClient.post(`/groups/${groupId}/stocks`, payload);
    if (response.status !== 200) throw new Error('Failed to associate stocks with group');
    return { groupId, data: response.data };
  },

  // Real community content lives in group_posts, not the disabled native
  // `posts` feature -- /posts/stock/symbol/{ticker} was always empty since
  // the `posts` table has zero rows in this app (the feature is off; native
  // posts were superseded by group posts). This hits the real, live data:
  // recent public posts from public groups that track this ticker.
  getPostsForStock: async (ticker, skip = 0, limit = 10) => {
    const response = await apiClient.get(`/group_posts/stock/${ticker}`, {
      params: { limit }
    });
    if (response.status !== 200) throw new Error('Failed to fetch posts for stock');
    return response.data;
  }
};

export default StockGroupAPI;
